import { cn } from '@/lib/utils';

const LIST_ITEM = /^\s*[-*•]\s+/;
const HEADING = /^#{1,3}\s+/;

export interface ReleaseNotesProps {
  notes: string | null | undefined;
  className?: string;
  emptyText?: string;
}

/**
 * Release notes are markdown-ish text typed by the owner: headings, bullet
 * lists and paragraphs. Rendered with three regexes rather than a markdown
 * library — nothing here is ever interpreted as HTML.
 */
export function ReleaseNotes({ notes, className, emptyText = 'No release notes were provided.' }: ReleaseNotesProps) {
  const text = notes?.replace(/\r\n/g, '\n').trim() ?? '';
  if (!text) return <p className={cn('text-sm text-muted-foreground', className)}>{emptyText}</p>;
  const blocks = text.split(/\n{2,}/);
  return (
    <div className={cn('space-y-3 text-sm leading-6', className)}>
      {blocks.map((block, index) => {
        const lines = block.split('\n');
        const key = `${index}-${block.slice(0, 24)}`;
        if (lines.every((line) => LIST_ITEM.test(line))) {
          return (
            <ul key={key} className="list-disc space-y-1 ps-5">
              {lines.map((line) => (
                <li key={line}>{line.replace(LIST_ITEM, '')}</li>
              ))}
            </ul>
          );
        }
        if (lines.length === 1 && HEADING.test(block)) {
          return (
            <p key={key} className="text-[15px] font-semibold">
              {block.replace(HEADING, '')}
            </p>
          );
        }
        return (
          <p key={key} className="whitespace-pre-wrap">
            {block}
          </p>
        );
      })}
    </div>
  );
}
